var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockedVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H10C4.47715 0 0 4.47715 0 10V50C0 55.5228 4.47715 60 10 60H50C55.5228 60 60 55.5228 60 50V10C60 4.47715 55.5228 0 50 0Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.877 25.567V20.599C40.8749 18.3193 39.9685 16.1336 38.3568 14.5213C36.7451 12.909 34.5597 12.0019 32.28 11.999L27.72 11.999C25.4398 12.0011 23.2536 12.9079 21.6412 14.5202C20.0289 16.1326 19.1221 18.3188 19.12 20.599V25.57C17.9447 25.866 16.9015 26.5452 16.1553 27.5003C15.4092 28.4554 15.0027 29.632 15 30.844V42.088C15 43.5364 15.5754 44.9254 16.5995 45.9495C17.6236 46.9737 19.0127 47.549 20.461 47.549H39.539C40.9873 47.549 42.3764 46.9737 43.4005 45.9495C44.4246 44.9254 45 43.5364 45 42.088V30.844C44.9978 29.6311 44.5912 28.4535 43.8444 27.4977C43.0976 26.5419 42.0534 25.8625 40.877 25.567ZM27.72 16.381H32.28C33.3988 16.3813 34.4717 16.8257 35.263 17.6166C36.0543 18.4075 36.4992 19.4802 36.5 20.599V25.386H23.5V20.599C23.5008 19.4802 23.9457 18.4075 24.737 17.6166C25.5283 16.8257 26.6012 16.3813 27.72 16.381Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedVideo);
export default __webpack_public_path__ + "static/media/locked-video.56a4a453.svg";
export { ForwardRef as ReactComponent };